"use client";

import { Languages } from "lucide-react";
import { useLocale, useTranslations } from "next-intl";
import { useTransition } from "react";

import { usePathname, useRouter } from "@/i18n/navigation";

const languages = [
  { locale: "pt-BR", label: "Português" },
  { locale: "en-GB", label: "English" },
  { locale: "es-ES", label: "Español" },
] as const;

export function PublicLanguageSelect() {
  const locale = useLocale();
  const t = useTranslations("Language");
  const pathname = usePathname();
  const router = useRouter();
  const [pending, startTransition] = useTransition();

  return <label className="relative inline-flex min-h-11 shrink-0 items-center rounded-lg text-sm text-foreground focus-within:ring-2 focus-within:ring-accent">
    <Languages aria-hidden="true" size={16} className="pointer-events-none absolute left-2.5" />
    <span className="sr-only">{t("settingsLabel")}</span>
    <select
      value={locale}
      disabled={pending}
      aria-busy={pending}
      className="min-h-11 max-w-36 cursor-pointer rounded-lg bg-transparent py-2 pl-8 pr-1 outline-none disabled:opacity-60"
      onChange={event => {
        const nextLocale = event.target.value;
        if (nextLocale !== locale && languages.some(item => item.locale === nextLocale)) {
          startTransition(() => router.replace(`${pathname}${window.location.search}${window.location.hash}`, { locale: nextLocale, scroll: false }));
        }
      }}
    >
      {languages.map(item => <option key={item.locale} value={item.locale} lang={item.locale}>{item.label}</option>)}
    </select>
  </label>;
}
